import React from 'react'
import useSWR from 'swr'
import BackLink from '@/components/BackLink'
import Container from '@/components/Container'
import HaveQuestions from '@/components/HaveQuestions'
import Title from '@/components/Title'
import Head from './components/Head'
import MoreInstitutions from './components/MoreInstitutions'
import Specialties from './components/Specialties'
import { usePage } from '@/hooks'
import { gameDetailMain } from '@/images'
import { api } from '@/api'

const InstitutionDetail = (): React.ReactElement => {
  const page = usePage()
  const { object } = page?.init_state
  const { config } = page.init_state.global
  const { data = {} } = useSWR({ id: object.id }, api.getInstitutionDetail)

  const {
    name = '',
    property_education_value: propertyEducationValue = '',
    property_link_value: propertyLinkValue = '',
    preview_picture: previewPicture = gameDetailMain,
    property_address_value: propertyAddressValue = '',
    property_email_value: propertyEmailValue = '',
    property_phone_value: propertyPhoneValue = '',
    property_region_value: propertyRegionValue = '',
    property_special_value: propertySpecialValue = [],
    detail_text: detailText = ''
  } = data

  return (
    <>
      <Container>
        <BackLink
          href={config.best_in_profession}
          title='Стань лучшим в профессии'
        />
        <Title type='h1' hidden>
          {name}
        </Title>

        <Head
          logo={previewPicture}
          name={name}
          state={propertyRegionValue}
          address={propertyAddressValue}
          site={propertyLinkValue}
          description={detailText}
          level={propertyEducationValue}
          email={propertyEmailValue}
          phone={propertyPhoneValue}
        />

        <Specialties specialties={propertySpecialValue} />

        <MoreInstitutions />
      </Container>

      <HaveQuestions />
    </>
  )
}

export default InstitutionDetail
